import { Box, Card, Skeleton, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { tableBodyCellSx, tableCardSx, tableHeadCellSx } from "../common/tableStyles";

export default function TableLoading() {
    const columns = Array.from({ length: 6 });
    const rows = Array.from({ length: 8 });

    return (
        <Card elevation={0} sx={tableCardSx}>
            <Box sx={{ display: "flex", justifyContent: "space-between", gap: 2, px: 2, py: 2 }}>
                <Skeleton variant="rounded" height={40} width="40%" />
                <Skeleton variant="rounded" height={40} width={160} />
            </Box>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        {columns.map((_, index) => (
                            <TableCell key={index} sx={tableHeadCellSx}>
                                <Skeleton width="70%" />
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((_, rowIndex) => (
                        <TableRow key={rowIndex}>
                            {columns.map((_, cellIndex) => (
                                <TableCell key={cellIndex} sx={tableBodyCellSx}>
                                    <Skeleton width="80%" />
                                </TableCell>
                            ))}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </Card>
    );
}
